import './SingleCaseStudies.scss';

function sameOrigin(uri1, uri2 = false) {
  if (!uri2) uri2 = window.location.href;
  uri1 = new URL(uri1);
  uri2 = new URL(uri2);
  if (uri1.host !== uri2.host) return false;
  if (uri1.port !== uri2.port) return false;
  if (uri1.protocol !== uri2.protocol) return false;
  return true;
}

var historyLink = function (e) {

  var previousUrl = document.referrer;
  if (sameOrigin(previousUrl) == true) {
    window.history.back();
    e.preventDefault();
  }

}

var backButton = document.getElementById('back');
backButton.addEventListener('click', (e) => {
  historyLink(e);
})

ComponentManager.init(document.body);
